import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function CortesCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ORDENES_CORTE = process.env.REACT_APP_URL_ORDENES_CORTE;
  const URL_CORTES = process.env.REACT_APP_URL_CORTES;
  const URL_ARTICULOS_ORDENES_CORTE =
    process.env.REACT_APP_URL_ARTICULOS_ORDENES_CORTE;
  const URL_ARTICULOS_CORTES = process.env.REACT_APP_URL_ARTICULOS_CORTES;
  const URL_INVENTARIOS_TELAS = process.env.REACT_APP_URL_INVENTARIOS_TELAS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const ordenTallas = ["2XCH","XCH","EXTRA CHICA","CHICA","CH","M","MEDIANA","GRANDE","G","EXTRA GRANDE","XG","2XG","XXG","3XG","XXXG","4XG","XXXXG","5XG","XXXXXG","ESP","VARIOS","2","4","6","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31","32","33","34","35","36","37","38","39","40","41","42","43","44","45","46","47","48","49","50","51","52","53","54","55","56"];

  const [ordenesCorte, setOrdenesCorte] = useState([]);
  const [selectedOrden, setSelectedOrden] = useState("");
  const [idArticulo, setIdArticulo] = useState("");
  const [value, setValue] = useState("");
  const [colaboradores, setColaboradores] = useState([]);
  const [cliente, setCliente] = useState("");
  const [idCliente, setIdCliente] = useState("");
  const [idPedido, setIdPedido] = useState("");
  const [fecha, setFecha] = useState(hoy);
  const [mesa, setMesa] = useState(0);
  const [fecha_compromiso, setFechaCompromiso] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [total_piezas, setTotalPiezas] = useState(0);
  const [piezas, setPiezas] = useState(0);
  const [lienzos, setLienzos] = useState(0);
  const [empalmes, setEmpalmes] = useState(0);
  const [retaceria, setRetaceria] = useState(0);
  const [largoTrazo, setLargoTrazo] = useState(0);
  const [responsable1, setResponsable1] = useState(
    "6275525ae9b2950360d3fa02"
  );
  const [responsable2, setResponsable2] = useState(
    "6275525ae9b2950360d3fa02"
  );
  const [tiempoInicio, setTiempoInicio] = useState("");
  const [tiempoFin, setTiempoFin] = useState("");

  const [articulosOrden, setArticulosOrden] = useState([]);
  const [fecha_orden, setFechaOrden] = useState("");
  const [total_piezas_orden, setTotalPiezasOrden] = useState(0);
  const [total_general_orden, setTotalGeneralOrden] = useState(0);

  const [articulosUnicos, setArticulosUnicos] = useState([]);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  useStyles();

  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      cantidad: 0,
      idArticulosOrden: "",
      idArticulo: "",
      idArticulosOC: "",
      tc: [],
      arrayColoresArticulo: [],
    },
  ]);

  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    axios
      .get(`${URL_ORDENES_CORTE}NoCortadas`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        setOrdenesCorte(res.data);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_COLABORADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        setColaboradores(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [URL_ORDENES_CORTE, URL_COLABORADORES]);

  const saveCorte = async (event) => {
    event.preventDefault();

    if (fecha === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Faltan Datos",
      });
      return;
    }

    setValidaBoton(false);
    toggleProgreso();

    try {
      const { data } = await axios.post(
        URL_CORTES,
        {
          fecha,
          mesa,
          ordenesCorte: selectedOrden,
          pedidos: idPedido,
          total_cantidad: total_piezas,
          lienzos,
          piezas,
          observaciones,
          empalmes,
          retaceria,
          largoTrazo,
          tiempoInicio,
          tiempoFin,
          responsable1,
          responsable2,
          status: "Abierto",
          articulos: idArticulo,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );

      await axios.patch(
        `${URL_INVENTARIOS_TELAS}/cortesCreate/${selectedOrden}`,
        { cortes: data._id },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );

      let combinacionesValidas = [];
      inputFields.forEach((f) => {
        if (Array.isArray(f.tc)) {
          f.tc.forEach((item) => {
            if (parseFloat(item.cantidad) > 0 && item.idArticulosOC) {
              combinacionesValidas.push(item);
            }
          });
        }
      });

      if (combinacionesValidas.length === 0) {
        await axios.post(
          URL_LOGS,
          {
            tipo: "Crear Corte",
            detalle: `${data._id}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );

        Swal.fire("Good job!", "Creado con éxito (sin artículos)", "success");
        return;
      }

      let totalPendientes = combinacionesValidas.length;
      let errores = [];

      combinacionesValidas.forEach((item) => {
        axios
          .post(
            URL_ARTICULOS_CORTES,
            {
              cortes: data._id,
              pedidos: idPedido,
              articulosOrdenesCorte: item.idArticulosOC,
              total_cantidad: parseFloat(item.cantidad),
              cantidad_procesos: parseFloat(item.cantidad),
              faltanteRecibir: parseFloat(item.cantidad),
              fecha,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {
            totalPendientes--;
            if (totalPendientes === 0) finalizarCorte(data._id);
          })
          .catch((error) => {
            errores.push(error);
            totalPendientes--;
            if (totalPendientes === 0) finalizarCorte(data._id, errores);
          });
      });
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Error al crear corte",
        footer: `${error.response?.data || error.message}`,
      });
      setValidaBoton(true);
    }
  };

  const finalizarCorte = (id, errores = []) => {
    axios
      .post(
        URL_LOGS,
        {
          tipo: "Crear Corte",
          detalle: `${id}`,
          user: user.id,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        if (errores.length === 0) {
          Swal.fire("Good job!", "Creado con éxito", "success");
          setTimeout(() => window.location.reload(), 1000);
        } else {
          console.error("Errores al guardar artículos:", errores);
          Swal.fire({
            icon: "warning",
            title: "Corte creado, pero hubo errores en artículos",
            text: `${errores.length} artículo(s) fallaron`,
          });
          setValidaBoton(true);
        }
      })
      .catch((error) => {
        console.error(error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Error al registrar log",
          footer: `${error.response?.data || error.message}`,
        });
        setValidaBoton(true);
      });
  };

  const handleAddFields = () => {
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        cantidad: 0,
        idArticulosOrden: "",
        idArticulo: "",
        idArticulosOC: "",
        tc: [],
        arrayColoresArticulo: [],
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    ActualizaTotales(values);
  };

  function BuscaArticulo(id, event) {
    const idArticuloSeleccionado = event.target.value;
    setIdArticulo(idArticuloSeleccionado);

    const articulosDelArticulo = articulosOrden.filter(
      (a) => String(a.idArticulo) === String(idArticuloSeleccionado)
    );

    if (articulosDelArticulo.length === 0) return;

    const colorMap = new Map();
    const coloresUnicos = [];

    articulosDelArticulo.forEach((a) => {
      if (!colorMap.has(String(a.idColor))) {
        colorMap.set(String(a.idColor), true);
        coloresUnicos.push({
          _id: a.idColor,
          name: a.color,
        });
      }
    });

    const agrupadoMap = new Map();

    articulosDelArticulo.forEach((a) => {
      const key = [
        String(a.idAreasClientes || ""),
        String(a.idArticulo || ""),
        String(a.idTalla || ""),
        String(a.idColor || ""),
      ].join("||");

      if (!agrupadoMap.has(key)) {
        agrupadoMap.set(key, {
          idArticulo: a.idArticulo,
          articuloNombre: a.articuloNombre,
          color: a.color,
          idColor: a.idColor,
          talla: a.talla,
          idTalla: a.idTalla,
          cantidad: parseFloat(a.cantidad || 0),
          idArticulosOC: a.idArticulosOC || a._id,
          areasClientes: a.areasClientes || "",
          idAreasClientes: a.idAreasClientes || "",
        });
      } else {
        const existente = agrupadoMap.get(key);
        existente.cantidad =
          parseFloat(existente.cantidad || 0) + parseFloat(a.cantidad || 0);
      }
    });

    const combinaciones = Array.from(agrupadoMap.values());

    const total = combinaciones.reduce(
      (sum, a) => sum + (parseFloat(a.cantidad) || 0),
      0
    );
    setTotalPiezas(total);

    const nuevos = [...inputFields];
    const index = nuevos.findIndex((f) => f.id === id);
    if (index !== -1) {
      nuevos[index].idArticulo = idArticuloSeleccionado;
      nuevos[index].arrayColoresArticulo = coloresUnicos;
      nuevos[index].tc = combinaciones;
      setInputFields(nuevos);
    }

    handleChangeInputArticulo(id, idArticuloSeleccionado);
  }

  const handleChangeInputArticulo = (id, idArticuloValue) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        return {
          ...i,
          idArticulo: idArticuloValue,
        };
      }
      return i;
    });
    setInputFields(newInputFields);
  };

  function ActualizaTotales(fields = inputFields) {
    let total = 0;
    fields.forEach((f) => {
      if (Array.isArray(f.tc)) {
        f.tc.forEach((t) => {
          total += parseFloat(t.cantidad) || 0;
        });
      }
    });
    setTotalPiezas(total);
  }

  function jalaOrden(e) {
    setSelectedOrden(e);

    axios
      .get(`${URL_ARTICULOS_ORDENES_CORTE}/orden/${e}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulosOrden = res.data;

        const arrayTabla = allArticulosOrden.map((a) => {
          const articulo = a.articulos?.[0];
          const talla = a.tallas?.[0];
          const color = a.colores?.[0];
          const area = a.areasClientes?.[0];
          const variante = talla?.variantesTallas?.[0];

          return {
            _id: a._id,
            idArticulo: articulo?._id || "",
            articuloNombre: articulo
              ? `${articulo.codigo} / ${articulo.codigoCliente} / ${articulo.descripcion}`
              : "",
            talla: talla
              ? `${talla.name}${variante?.name ? " " + variante.name : ""}`
              : "",
            idTalla: talla?._id || "",
            color: color?.name || "",
            idColor: color?._id || "",
            cantidad: a.pendiente_cortar,
            cantidadOrden: a.cantidad,
            areasClientes: area?.name || "",
            idAreasClientes: area?._id || "",
            idArticulosOC: a._id,
          };
        });

        const dataFinal = Object.values(arrayTabla);
        setArticulosOrden(dataFinal);
        setIdArticulo(dataFinal?.[0]?.idArticulo || "");

        const agrupado = dataFinal.reduce((groups, item) => {
          const val = item.idArticulo;
          groups[val] = groups[val] || {
            idArticulo: item.idArticulo,
          };
          groups[val].idArticulo = item.idArticulo;
          groups[val].articuloNombre = item.articuloNombre;
          return groups;
        }, {});
        const dataFinalAgru = Object.values(agrupado);
        setArticulosUnicos(dataFinalAgru);

        setInputFields((prev) => [
          {
            ...prev[0],
            tc: dataFinal,
            arrayColoresArticulo: [],
          },
        ]);

        ActualizaTotales([
          {
            ...inputFields[0],
            tc: dataFinal,
            arrayColoresArticulo: [],
          },
        ]);
      })
      .catch((err) => {
        console.log(err);
      });

    ordenesCorte.forEach((a) => {
      if (a._id == e) {
        setFechaOrden(a.fecha);
        setCliente(a.pedidos[0].clientes[0].nombre_comercial);
        setIdCliente(a.pedidos[0].clientes[0]._id);
        setIdPedido(a.pedidos[0]._id);
      }
    });
  }

  const handleChangeInputCantidad = (
    idField,
    idColor,
    idTalla,
    idArea,
    event
  ) => {
    const nuevos = [...inputFields];
    const index = nuevos.findIndex((f) => f.id === idField);
    if (index === -1) return;

    nuevos[index].tc = nuevos[index].tc.map((item) => {
      if (
        String(item.idColor) === String(idColor) &&
        String(item.idTalla) === String(idTalla) &&
        String(item.idAreasClientes) === String(idArea)
      ) {
        return {
          ...item,
          cantidad: parseFloat(event.target.value) || 0,
        };
      }
      return item;
    });

    setInputFields(nuevos);
    ActualizaTotales(nuevos);
  };

  const options = ordenesCorte.map((option) => {
    const junta =
      option.idOrdenesCorte +
      " " +
      option.pedidos[0].clientes[0].nombre_comercial +
      " " +
      option.articulos[0].codigo;
    const firstLetter = option.idOrdenesCorte.toString();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_produccion ? (
        <div className="card container col-10">
          <h3 align="center">Nuevo Corte</h3>
          <Form>
            <Row>
              <Col md={3}>
                <Label className="mr-sm-2">Orden de Produccion</Label>
                <Autocomplete
                  size="small"
                  value={value}
                  onChange={(event, selectedOrdenAuto) => {
                    if (selectedOrdenAuto) {
                      setValue(selectedOrdenAuto);
                      jalaOrden(selectedOrdenAuto._id);
                    }
                  }}
                  options={options.sort((a, b) =>
                    -b.firstLetter.localeCompare(a.firstLetter)
                  )}
                  groupBy={(option) => option.firstLetter}
                  getOptionLabel={(option) => option.junta}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Selecciona"
                      variant="outlined"
                    />
                  )}
                  renderOption={(option) => (
                    <React.Fragment>
                      {option.idOrdenesCorte}{" "}
                      {option.pedidos[0].clientes[0].nombre_comercial}{" "}
                      {option.articulos[0].codigo}
                    </React.Fragment>
                  )}
                />
              </Col>

              <Col md={2}>
                <Label>Fecha Orden</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha_orden}
                  required
                  disabled
                  onChange={(e) => {
                    setFechaOrden(e.target.value);
                  }}
                />
              </Col>

              <Col md={3}>
                <Label>Cliente</Label>
                <Input
                  type="text"
                  placeholder="Cliente"
                  value={cliente}
                  required
                  disabled
                  onChange={(e) => {
                    setCliente(e.target.value);
                  }}
                />
              </Col>

              <Col md={2}>
                <Label>Fecha Corte</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha}
                  required
                  onChange={(e) => {
                    setFecha(e.target.value);
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col md={2}>
                <Label>Hora Inicio</Label>
                <Input
                  type="datetime-local"
                  value={tiempoInicio}
                  required
                  onChange={(e) => {
                    setTiempoInicio(e.target.value);
                  }}
                />
              </Col>

              <Col md={2}>
                <Label>Hora Fin</Label>
                <Input
                  type="datetime-local"
                  value={tiempoFin}
                  required
                  onChange={(e) => {
                    setTiempoFin(e.target.value);
                  }}
                />
              </Col>

              <Col md={2}>
                <Label>Piezas</Label>
                <Input
                  type="number"
                  placeholder="Piezas"
                  value={piezas}
                  required
                  onChange={(e) => {
                    setPiezas(e.target.value);
                  }}
                />
              </Col>

              <Col md={2}>
                <Label>Observaciones</Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <h4 id="logoutBoton">
                  TOTALES {new Intl.NumberFormat("en-US").format(total_piezas)}{" "}
                  pzas.
                </h4>
              </Col>
            </Row>

            <br />

            {/* <Row>
              <Col md={3}>
                <Label className="mr-sm-2">Articulos</Label>
              </Col>
            </Row> */}

            {inputFields.map((inputField) => {
              const dataAgrupada = {};

              if (Array.isArray(inputField.tc)) {
                inputField.tc.forEach((item) => {
                  const area = item.areasClientes || "Sin área";
                  const articulo = item.articuloNombre || "Sin artículo";
                  const color = item.color || "Sin color";

                  if (!dataAgrupada[area]) dataAgrupada[area] = {};
                  if (!dataAgrupada[area][articulo])
                    dataAgrupada[area][articulo] = {};
                  if (!dataAgrupada[area][articulo][color]) {
                    dataAgrupada[area][articulo][color] = [];
                  }

                  dataAgrupada[area][articulo][color].push(item);
                });
              }

              return (
                <div key={inputField.id} className="mb-4">
                  {/* <Row>
                    <Col md={3}>
                      <Input
                        bsSize="sm"
                        name="idArticulo"
                        type="select"
                        value={inputField.idArticulo}
                        onChange={(event) => {
                          BuscaArticulo(inputField.id, event);
                        }}
                      >
                        <option value="">Selecciona un Articulo</option>
                        {articulosUnicos
                          .sort((a, b) =>
                            a.articuloNombre > b.articuloNombre ? 1 : -1
                          )
                          .map((a) => (
                            <option key={a.idArticulo} value={a.idArticulo}>
                              {a.articuloNombre}
                            </option>
                          ))}
                      </Input>
                    </Col>
                  </Row>

                  <br /> */}

                  {Object.entries(dataAgrupada).map(([area, articulos]) => (
                    <div key={area} className="mb-4">
                      <h5 style={{ fontWeight: "700", color: "#2f4f4f" }}>
                        Área: {area}
                      </h5>

                      {Object.entries(articulos).map(
                        ([articuloNombre, colores]) => (
                          <div key={articuloNombre} className="mb-4">
                            <h6 style={{ fontWeight: "700", color: "#000" }}>
                              {articuloNombre}
                            </h6>

                            {Object.entries(colores).map(
                              ([colorNombre, items]) => {
                               const itemsOrdenados = [...items].sort((a, b) => {
  const tallaA = (a.talla || "").trim();
  const tallaB = (b.talla || "").trim();

  const partesA = tallaA.split(" ");
  const partesB = tallaB.split(" ");

  const baseA = partesA[0] || "";
  const baseB = partesB[0] || "";

  const varianteA = partesA.slice(1).join(" ").trim();
  const varianteB = partesB.slice(1).join(" ").trim();

  const sinVarianteA = varianteA === "";
  const sinVarianteB = varianteB === "";

  // 1. Primero las que no tienen variante
  if (sinVarianteA && !sinVarianteB) return -1;
  if (!sinVarianteA && sinVarianteB) return 1;

  // 2. Luego ordenar por ordenTallas
  const indexA = ordenTallas.indexOf(baseA);
  const indexB = ordenTallas.indexOf(baseB);

  const ordenBaseA = indexA === -1 ? Infinity : indexA;
  const ordenBaseB = indexB === -1 ? Infinity : indexB;

  if (ordenBaseA !== ordenBaseB) {
    return ordenBaseA - ordenBaseB;
  }

  // 3. Si tienen la misma talla base, ordenar alfabéticamente la variante
  return varianteA.localeCompare(varianteB, "es", { numeric: true });
});

                                const totalColor = itemsOrdenados.reduce(
                                  (sum, item) =>
                                    sum + (parseFloat(item.cantidad) || 0),
                                  0
                                );

                                return (
                                  <div
                                    key={`${area}_${articuloNombre}_${colorNombre}`}
                                    className="mb-4"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "20px",
                                      flexWrap: "wrap",
                                      borderBottom: "1px solid #e9ecef",
                                      paddingBottom: "16px",
                                      marginBottom: "16px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        minWidth: "190px",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <div
                                        style={{
                                          fontWeight: "800",
                                          fontSize: "18px",
                                          color: "#557c55",
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        {colorNombre}
                                      </div>
                                      <div
                                        style={{
                                          fontSize: "15px",
                                          color: "#6c757d",
                                        }}
                                      >
                                        Total color:{" "}
                                        <strong>
                                          {new Intl.NumberFormat("en-US").format(
                                            totalColor
                                          )}
                                        </strong>
                                      </div>
                                    </div>

                                    <div
                                      className="d-flex flex-wrap"
                                      style={{
                                        gap: "24px",
                                        flex: 1,
                                      }}
                                    >
                                      {itemsOrdenados.map((a) => (
                                        <div
                                          key={`${a.idAreasClientes}_${a.idArticulo}_${a.idTalla}_${a.idColor}`}
                                          className="text-center"
                                          style={{
                                            minWidth: "88px",
                                          }}
                                        >
                                          <Label
                                            style={{
                                              color: "#314a7d",
                                              fontWeight: "600",
                                              marginBottom: "6px",
                                              display: "block",
                                            }}
                                          >
                                            {a.talla}
                                          </Label>

                                          <Input
                                            bsSize="sm"
                                            type="number"
                                            value={a.cantidad}
                                            onChange={(event) =>
                                              handleChangeInputCantidad(
                                                inputField.id,
                                                a.idColor,
                                                a.idTalla,
                                                a.idAreasClientes,
                                                event
                                              )
                                            }
                                            style={{
                                              width: "84px",
                                              textAlign: "center",
                                              margin: "0 auto",
                                              borderRadius: "10px",
                                              border: "1px solid #ced4da",
                                            }}
                                          />
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                );
                              }
                            )}
                          </div>
                        )
                      )}
                    </div>
                  ))}
                </div>
              );
            })}

            <Row>
              <Col md={12}>
                <h4 id="logoutBoton">
                  TOTALES {new Intl.NumberFormat("en-US").format(total_piezas)}{" "}
                  pzas
                </h4>
              </Col>
            </Row>
          </Form>

          <br />

          <Row>
            <Col>
              {validaBoton ? (
                <Button
                  type="submit"
                  className="btn btn-success"
                  tabIndex="-1"
                  onClick={saveCorte}
                >
                  Guardar
                </Button>
              ) : (
                <Button
                  type="submit"
                  className="btn btn-success"
                  disabled
                  tabIndex="-1"
                >
                  Guardar
                </Button>
              )}

              <Button
                href="/ListadoCortes"
                className="btn btn-danger"
                id="botonListado"
                tabIndex="-1"
              >
                Regresar
              </Button>
            </Col>
          </Row>

          <br />

          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                Este proceso puede tardar varios minutos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default CortesCreate;